import request from '@/utils/request'
const baseUrl = '/ims'

// 身份验证
export function verifyIdentity(data) {
  return request({
    url: baseUrl + `/Uapi/verifyIdentity?code=${data.code}&uuid=${data.uuid}`,
    method: 'POST',
    data
  })
}

export function dictByType(code) {
  return request({
    url: baseUrl + `/SystemApi/dict/data/${code}`,
    method: 'GET'
  })
}

export function dictData(params) {
  return request({
    url: baseUrl + `/DictData/simple`,
    method: 'GET',
    params
  })
}


// 下载文件
export function downloadToFile(params) {
  return request({
    url: baseUrl + '/file/downloadToFile',
    method: 'GET',
    params,
    responseType: 'blob'
  })
}

// 文件上传
export function fileUpload(data) {
  return request({
    url: `/file/inner/upload`,
    method: 'POST',
    data,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 身份信息下拉列表
export function identitySimple(params) {
  return request({
    url: baseUrl + `/Uapi/role/identity/simple`,
    method: 'GET',
    params
  })
}

export function menuByRole(params) {
  return request({
    url: baseUrl + '/Uapi/menu/query/forMemberRole',
    method: 'GET',
    params
  })
}

// 部门人员选择器
export function userChooseQuery(params) {
  return request({
    url: baseUrl + `/Uapi/dept/userChooseQuery`,
    method: 'GET',
    params
  })
}

export function moduleList(params) {
  return request({
    url: baseUrl + `/ModuleApi/list`,
    method: 'GET',
    params
  })
}


export function fetchRobotConfig(params) {
  return request({
    url: `/auth/config/robot`,
    method: 'GET',
    params
  })
}

export function fetchRsaPublicKey(params) {
  return request({
    url: `/upms/auth/rsa/publicKey`,
    method: 'GET',
    params
  })
}

